import { Poll } from 'schema/poll';
import { ICState } from 'schema/state';
import { selectGroup } from '../../selects';
import { reduceQuestionGroup } from '../reducers';

export function shouldRecalculateVisibleQuestions(state: ICState, data: Poll): state is ICState & { groupId: string } {
  if (!state.groupId) {
    return false;
  }

  const group = selectGroup(data, state.groupId);
  return !group.data.hasSequentialDisplay;
}

export function recalculateVisibleQuestions(prevState: ICState & { groupId: string }, poll: Poll) {
  return reduceQuestionGroup({
    poll,
    prevState,
    groupId: prevState.groupId,
    recalculateVisibleQuestions: true,
  });
}
